// Component to detect unload events
// Calls a passed callback when warning should be shown (so e.g. some state can be set)
// Calls it with 'false' as argument when warning should leave
// Can take an 'active' prop so the component is only active when e.g. unsaved data is on the page

import { useEffect } from "react";

interface OnBeforeUnloadProps {
  //  onUnload: (trigger: boolean) => void;
  active?: boolean;
}

export function OnBeforeUnload({ active = true }: OnBeforeUnloadProps) {
  useEffect(() => {
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      if (active) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [active]);

  return null;
}
